import { useState, useEffect, useCallback } from 'react';
import { getVendors } from '../api/vendor';
import { resolveVendorNameFromList } from '../utils/vendorEntity';

function normalizeList(data) {
  return Array.isArray(data) ? data : (data?.items || data?.data || []);
}

/**
 * Loads vendors once and exposes id → display-name resolution.
 * Shared by GRN, PO, and list screens to avoid duplicate lookup logic.
 */
export default function useVendorLookup() {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getVendors()
      .then(d => { if (active) setVendors(normalizeList(d)); })
      .catch(() => { if (active) setVendors([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const resolveVendorName = useCallback(
    (vendorId) => resolveVendorNameFromList(vendorId, vendors),
    [vendors],
  );

  return { vendors, loading, resolveVendorName };
}
